module.exports = __webpack_public_path__ + "static/img/avatar_r_8.a51978f5.png";